import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotificationModel } from 'src/app/models/notification.model';
import { BaseService } from '../../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService<NotificationModel> {
  hasUnreadMessagesChanges = new BehaviorSubject<boolean>(false);
  constructor(protected http: HttpClient) {
    super(http, 'notifications');
  }

  retrieveNotification(
    id: number | string | undefined
  ): Observable<HttpResponse<NotificationModel>> {
    return this.http.get<NotificationModel>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }
}
